import { apiClient, clean } from "./apiClient";
import type { PageRequest, PageResponse } from "@/types/api";
import type { LegalEntityFilter, LegalEntitySummary } from "@/types/entities";

export const legalEntitiesService = {
  list(filter: LegalEntityFilter, page: PageRequest): Promise<PageResponse<LegalEntitySummary>> {
    return apiClient
      .get<PageResponse<LegalEntitySummary>>("/legal-entities", { params: { ...clean(filter), ...clean(page) } })
      .then((r) => r.data);
  },
  getOne: (id: string) =>
    apiClient.get(`/legal-entities/${id}`).then((r) => r.data),
  create: (body: { displayName: string; [key: string]: unknown }) =>
    apiClient.post("/legal-entities", body).then((r) => r.data),
  // Atlas API treats PATCH /legal-entities/{id} as a full replacement: any
  // field absent from the body is set to null on the row. Fetch the current
  // record first and merge the patch on top so the server receives the full
  // entity and only the explicitly-changed fields actually change.
  update: async (id: string, body: Record<string, unknown>) => {
    const current = await apiClient
      .get<Record<string, unknown>>(`/legal-entities/${id}`)
      .then((r) => r.data);
    const merged = { ...current, ...body };
    return apiClient.patch(`/legal-entities/${id}`, merged).then((r) => r.data);
  },
  remove: (id: string) =>
    apiClient.delete(`/legal-entities/${id}`),
};